module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/pinterest-c601c8d1a151227901cd93070bcf2236.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/pinterest.svg
// module id = L0ze
// module chunks = 24